var _path;
import * as React from "react";
function SvgComboInsightsVerticalBorderNegative(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.972 58.572a2.5 2.5 0 01-1.472-2.28V7A1.5 1.5 0 014 5.5h26A1.5 1.5 0 0131.5 7v49.293a2.5 2.5 0 01-1.472 2.279l-12.411 5.601a1.5 1.5 0 01-1.234 0L3.972 58.571z"
  })));
}
export default SvgComboInsightsVerticalBorderNegative;